export const ep = {
  occupations: {
    occupations: '/Occupations',
  },
  autoComplete: {
    occupations: '/OccupationListItems',
  },
  referenceType: {
    salaryRanges: '/Salaries',
    workExperiences: '/WorkExperiences',
    educationLevels: '/EducationLevels',
    similarities: '/Similarities',
  },
  system: {
    configurations: '/configurations',
  }
}
